module.exports = __webpack_public_path__ + "static/media/introduce.57f6eed7.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/data/carImages/远程E200仓栅车/introduce.png
// module id = 716
// module chunks = 0